import { Point, RegionInfo } from 'api/grpc/resources';
import { isBboxRegion, isMaskRegion, isPolygonRegion } from 'utils/typeguards/predictionOutputs';
import { convertJsBoundingBoxToGrpcBoundingBox, convertJsMasktoGrpcMask, convertJsPolygonToGrpcPolygon } from 'utils/grpc/jsToGrpc';
import { isPointRegion } from 'utils/annotations/point';

export const convertJsRegionInfoToGrpcRegionInfo = (rInfo: CF.API.RegionInfo): RegionInfo => {
  const regionInfo = new RegionInfo();

  if (isBboxRegion(rInfo)) {
    regionInfo.setBoundingBox(convertJsBoundingBoxToGrpcBoundingBox(rInfo.bounding_box));
  } else if (isPolygonRegion(rInfo)) {
    regionInfo.setPolygon(convertJsPolygonToGrpcPolygon(rInfo.polygon));
  } else if (isMaskRegion(rInfo)) {
    regionInfo.setMask(convertJsMasktoGrpcMask(rInfo.mask));
  } else if (isPointRegion(rInfo)) {
    // Fix: Use row and col instead of x and y
    const point = new Point();
    point.setRow(rInfo.point.row);
    point.setCol(rInfo.point.col);
    if (rInfo.point.z !== undefined) {
      point.setZ(rInfo.point.z);
    }
    regionInfo.setPoint(point);
  }

  return regionInfo;
};
